<template>
  <ul class="collection collection-alone with-header pb-4" id="filter3">
    <li class="collection-header pl-0">
      <span class="Search_title grey-text pl-0">{{title}}</span>
    </li>
    <li
      class="collection-item dismissable pb-0"
      style="
        touch-action: pan-y;
        -webkit-user-drag: none;
        -webkit-tab-highlight-color: rgba(0, 0, 0, 0);"
      v-for="item in estadosPadrao"
      v-bind:key="item.estado_id">
      <input
        type="checkbox"
        v-model="estados"
        :value="item.estado_id"
        :id="getIdNameEstado(item.estado_id)"
        v-on:change="$emit('change', estados)"
      />
      <label :for="getIdNameEstado(item.estado_id)"/>
      <span
        class="title title-alone"
        style="width: 100%">
        {{capitalizeFirstLetter(item.estado_nome)}}
      </span>
    </li>
  </ul>
</template>

<script>
import * as constant from "@/constants/pedidoEstagio";
import ConverterHelper from "@/helpers/converter";

export default {
  name: "FiltroPorEstados",

  components: {},

  props: {
    title: {
      type: String,
      default: undefined
    },
    estados: {
      type: Array,
      required: true
    }
  },

  data: () => ({
    estadosPadrao: [
      {
        estado_id: constant.ESTAGIO_NEGOCIACAO,
        estado_nome: ConverterHelper.getNameEstagio(constant.ESTAGIO_NEGOCIACAO)
      },
      {
        estado_id: constant.ESTAGIO_CHAMADA_TELEFONICA,
        estado_nome: ConverterHelper.getNameEstagio(constant.ESTAGIO_CHAMADA_TELEFONICA)
      },
      {
        estado_id: constant.ESTAGIO_PRIMEIRA_VISITA,
        estado_nome: ConverterHelper.getNameEstagio(constant.ESTAGIO_PRIMEIRA_VISITA)
      },
      {
        estado_id: constant.ESTAGIO_EFETIVADO,
        estado_nome: ConverterHelper.getNameEstagio(constant.ESTAGIO_EFETIVADO)
      },
      {
        estado_id: constant.ESTAGIO_NEGATIVADO,
        estado_nome: ConverterHelper.getNameEstagio(constant.ESTAGIO_NEGATIVADO)
      },
      {
        estado_id: constant.ESTAGIO_SEGUNDA_VISITA,
        estado_nome: ConverterHelper.getNameEstagio(
          constant.ESTAGIO_SEGUNDA_VISITA
        )
      },
      {
        estado_id: constant.ESTAGIO_EM_ESPERA,
        estado_nome: ConverterHelper.getNameEstagio(constant.ESTAGIO_EM_ESPERA)
      },
      {
        estado_id: constant.ESTAGIO_PERDIDO,
        estado_nome: ConverterHelper.getNameEstagio(constant.ESTAGIO_PERDIDO)
      }
    ]
  }),

  methods: {
    getIdNameEstado(id) {
      return `estado${id}`;
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/lead/listagem/FiltroPorEstados.vue